/**
 * Be careful when/where you use these functions as you could override
 * global styles in an application if you're not careful
 */

export function addGlobalStyleTag() {
  const hasStyleTag =
    document.querySelector('style[data-global-overrides="true"]') !== null;

  if (hasStyleTag) return;

  const styleTag = document.createElement('style');
  styleTag.dataset.globalOverrides = 'true';
  styleTag.innerText =
    '*,::after,::before{box-sizing:border-box}button:active{transform:scale(.99)}img{max-width:100%}';

  const firstChild = document.head?.firstElementChild;

  if (firstChild) {
    document.head.insertBefore(styleTag, firstChild);
  } else {
    document.head.append(styleTag);
  }
}

export function removeGlobalStyleTag() {
  const styleTag = document.querySelector(
    'style[data-global-overrides="true"]'
  );

  if (styleTag !== null) {
    const parent = styleTag.parentElement;
    // eslint-disable-next-line no-unused-expressions
    parent?.removeChild(styleTag);
  }
}
